RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {
    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    function pluralizeAndSet(table, props, freeDimension, data) {
        const rowProps = {};
        const filterKey = `${_.camelCase(freeDimension)}s`;
        rowProps[filterKey] = _.head(data[0]);
        rowProps.postsForDimension = freeDimension;

        return rowProps;
    }

    function companyIdFilter(table, props, freeDimension, data) {
        const rowProps = pluralizeAndSet(table, props, freeDimension, data);

        const company = RivalIQ.state.landscape.getCompanyById(_.head(data[0]));
        if (company) {
            rowProps.forName = company.get('name');
        }

        return rowProps;
    }

    function postTagFilter(table, props, freeDimension, data) {
        const postTagId = _.head(data[0]);

        if (postTagId === '__SUMMARY_ROW__') {
            return {};
        }

        const rowProps = {
            forName: _.get(table, ['dashboardModel', 'postTagsById', postTagId, 'tag_name']),
            mustHavePostTagIds: postTagId
        };

        return rowProps;
    }

    function keywordFilter(table, props, freeDimension, data) {
        const rowProps = {};

        const keyword = _.head(data[0]);

        if (keyword === '__SUMMARY_ROW__') {
            return {};
        }

        const keywordModel = table.collection.at(0).build({
            keyword: keyword,
            dimension: ['keyword'],
            property: 'post'
        }).getValue();

        if (keywordModel) {
            rowProps.postIds = keywordModel.get('postIds');
        }

        rowProps.forName = keyword;

        return rowProps;
    }

    function hashtagFilter(table, props, freeDimension, data) {
        const rowProps = {};

        const hashtag = _.head(data[0]);

        if (hashtag === '__SUMMARY_ROW__') {
            return {};
        }

        if (!_.isEmpty(props.searchTerm)) {
            rowProps.searchTerm = `(${props.searchTerm}) AND #${hashtag}`;
        } else {
            rowProps.searchTerm = `#${hashtag}`;
        }
        rowProps.forName = `#${hashtag}`;

        return rowProps;
    }

    const FreeDimensionFilterStrategy = {
        keyword: keywordFilter,
        hashtag: hashtagFilter,
        companyId: companyIdFilter,
        post_tag_id: postTagFilter
    };

    widgets.PostAggregatesTableRowClickMixin = {
        onRowClick: function (data, e, dimensionRow) {
            const me = this;

            const $target = $(e.target);

            if ($target.is('a') || me.getProp('noClickThrough')) {
                return;
            }

            const rowProps = me.getPostsModalProps(data, dimensionRow);

            const props = _.extend(me.getProps(), rowProps);

            const source = RivalIQ.data.channels.get(props.channel).get('channel');
            RivalIQ.apps.SocialPosts.views.PostsModal.show(props, source);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SocialPostsViewPostsModal, _.extend({
                widgetId: me.dashboardModel.widgetId
            }, rowProps));
        },

        getPostsModalProps: function (data, dimensionRow) {
            const me = this;

            const props = me.getProps();

            const baseMetric = me.metricsCollection.at(0);
            const freeDimension = _.head(baseMetric.getFreeDimensions());

            const strategy = _.get(FreeDimensionFilterStrategy, [freeDimension], pluralizeAndSet);

            const rowProps = strategy(me, props, freeDimension, data);

            // add in subordinate row info if present.
            if (dimensionRow) {
                const filterKey = `${_.camelCase(me.getProp('dimension'))}s`;
                const companyId = _.last(dimensionRow[0]);
                rowProps[filterKey] = [companyId];
            }

            return rowProps;
        },

        rowClassName: function () {
            const me = this;
            return (me.getProp('noClickThrough') ? '' : 'pointer');
        }
    };

    widgets.PostAggregatesTableView = Dashboard.widgets.MetricTable.mixin({

        className: function () {
            const me = this;
            const classes = Dashboard.widgets.MetricTable.prototype.className.apply(me);

            return `${classes} clickable-subordinate-rows`;
        },

        eventsNotToDebounce: {
            'click .x-sort': 'onSortClick',
            'click .table-expander': 'onExpanderClick',
            'click tbody tr': '_onRowClick'
        },

        mixins: {
            postAggregatesTableRowClickMixin: widgets.PostAggregatesTableRowClickMixin
        },

        rowClass: function (cells, i) {
            const me = this;

            let rowClass = Dashboard.widgets.MetricTable.prototype.rowClass.apply(me, arguments);
            if (_.get(cells, [0, 0]) === '__SUMMARY_ROW__') {
                rowClass += ' metric-summary-row';
            }

            return rowClass;
        }
    });


    const PostAggregatesTableWidget = Dashboard.widgets.TableWidget.extend({
        view: widgets.PostAggregatesTableView
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_POST_AGGREGATES_TABLE, PostAggregatesTableWidget);
});
